import React, { useState, useEffect } from "react";
import { ReactComponent as Special } from "./../../images/Icons/icons-special-events.svg";
import { ReactComponent as Unplanned } from "./../../images/Icons/icons-unplanned-disruption.svg";
import { ReactComponent as Planned } from "./../../images/Icons/icons-planned-disruption.svg";
import "./BottomMessageSection.scss";
import { useAuth } from "../../Context/Auth";

function BottomMessageSection(props) {
  const { stopPredictionsList, trackerId } = props;
  const emptySection = <div className="disruption-message empty"></div>;
  const { displayRecords } = useAuth();
  const [events, setEvents] = useState([]);
  const [displayEvtIndex, setDisplayEvtIndex] = useState(0);

  useEffect(() => {
    if (isValidStopPredictionsList(stopPredictionsList)) {
      const prediction = stopPredictionsList[0];

      let _tempEvents = [];
      // Process if has events
      if (
        "HasDisruption" in prediction &&
        (prediction.HasDisruption || "DisruptionMessage" in prediction) &&
        prediction.DisruptionMessage &&
        "Messages" in prediction.DisruptionMessage &&
        Array.isArray(prediction.DisruptionMessage.Messages) &&
        prediction.DisruptionMessage.Messages.length > 0 &&
        prediction.DisruptionMessage.Messages[0].Message
      ) {
        _tempEvents.push({
          component: Unplanned,
          className: "unplanned-disruption",
          msg: prediction.DisruptionMessage.Messages[0].Message,
        });
      }
      if (
        "HasPlannedOccupation" in prediction &&
        (prediction.HasPlannedOccupation ||
          "PlannedOccupationMessage" in prediction) &&
        prediction.PlannedOccupationMessage
      ) {
        _tempEvents.push({
          component: Planned,
          className: "planned-occupation",
          msg: prediction.PlannedOccupationMessage,
        });
      }
      if (
        "HasSpecialEvent" in prediction &&
        (prediction.HasSpecialEvent || "SpecialEventMessage" in prediction) &&
        prediction.SpecialEventMessage
      ) {
        _tempEvents.push({
          component: Special,
          className: "special-event",
          msg: prediction.SpecialEventMessage,
        });
      }
      setEvents(_tempEvents);
    }
  }, [stopPredictionsList]);

  useEffect(() => {
    if (Array.isArray(stopPredictionsList) && stopPredictionsList.length > 0) {
      const routeNum = stopPredictionsList[0].HeadBoardRouteNo;
      const visitedNum =
        displayRecords[(trackerId || "undefined") + "" + routeNum] || 0;
      setDisplayEvtIndex(visitedNum % events.length || 0);
    }
  }, [stopPredictionsList, events, displayRecords, trackerId]);

  if (!isValidStopPredictionsList(stopPredictionsList) || events.length === 0) {
    return emptySection;
  }

  function isValidStopPredictionsList(stopPredictionsList) {
    if (
      stopPredictionsList &&
      Array.isArray(stopPredictionsList) &&
      stopPredictionsList.length > 0
    ) {
      return true;
    }
    return false;
  }

  const renderEventIcon = (Component) => {
    return <Component className="event-svg-icon" />;
  };

  const selectedEvent = events[displayEvtIndex % events.length || 0];
  return (
    <div className={`disruption-message ${selectedEvent.className}`}>
      {selectedEvent &&
        "component" in selectedEvent &&
        renderEventIcon(selectedEvent.component)}
      {selectedEvent && "msg" in selectedEvent && <span>{selectedEvent.msg}</span>}
    </div>
  );
}
export default BottomMessageSection;
